import React, { useState } from "react";
import {
    Button,
    Col,
    Form,
    Input,
    Row,
    Card,
    Typography,
    Space,
    Divider,
    Alert
} from "antd";
import TextArea from "antd/es/input/TextArea";
import {
    CheckOutlined,
    RollbackOutlined,
    CalendarOutlined,
    TagOutlined,
    FileTextOutlined,
    SaveOutlined
} from "@ant-design/icons";
import {
    Add_ObjectOutOfService_Api
} from "../../API/ObjectOutOfServiceApi";
import {
    CustomTypeCombo
} from "../CustomType/CustomTypeCombo";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const { Title, Text } = Typography;
const SERVER_DATE_FORMAT = "YYYY-MM-DD";

export const AddObjectOutOfServiceComponent = ({
    objectInstanceId,
    objectInstanceTitle,
    setLoading,
    showMessage,
    rowInserted,
    cancelInsert,
    reasonParentId
}) => {
    const [form] = Form.useForm();
    const [reasonId, setReasonId] = useState();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    // تابع کمکی برای تبدیل کاراکترهای فارسی به لاتین
    const persianToLatinDigits = (str) => {
        if (!str) return '';
        const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
        const latinDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        let newStr = str;
        for (let i = 0; i < 10; i++) {
            const regex = new RegExp(persianDigits[i], 'g');
            newStr = newStr.replace(regex, latinDigits[i]);
        }
        return newStr;
    };

    // تابع کمکی برای تبدیل DateObject به رشته
    const formatDateForApi = (dateObject) => {
        if (!dateObject) return '';
        const formattedDate = dateObject.format('YYYY-MM-DD');
        return persianToLatinDigits(formattedDate);
    };

    // اعتبارسنجی تاریخ
    const validateDates = (from, to) => {
        if (!from || !to) return true;
        return from <= to;
    };

    const onSubmit = async (values) => {
        // اعتبارسنجی علت
        if (!reasonId) {
            showMessage("لطفاً علت را انتخاب کنید", "error");
            return;
        }

        // اعتبارسنجی تاریخ
        if (!values.fromDate_Shamsi || !values.toDate_Shamsi) {
            showMessage("لطفاً تاریخ شروع و پایان را وارد کنید", "error");
            return;
        }

        if (values.fromDate_Shamsi > values.toDate_Shamsi) {
            showMessage("تاریخ پایان نمی‌تواند قبل از تاریخ شروع باشد", "error");
            return;
        }

        // آماده‌سازی داده‌ها برای ارسال
        const formattedValues = {
            objectInstanceId: objectInstanceId,
            fromDate_Shamsi: formatDateForApi(values.fromDate_Shamsi),
            toDate_Shamsi: formatDateForApi(values.toDate_Shamsi),
            customTypeId: reasonId,
            description: values.description || "",
        };

        console.log(formattedValues)
        setLoading(true);

        try {
            const data = await Add_ObjectOutOfService_Api(formattedValues);
            setLoading(false);

            if (data.messageStatus === "Successful") {
                showMessage("رکورد با موفقیت ثبت شد", "success");
                form.resetFields();
                setReasonId(null);
                setFromDate(null);
                setToDate(null);
                cancelInsert();
                //rowInserted();
            } else {
                showMessage(data.message || "خطا در ثبت اطلاعات", "error");
            }
        } catch (error) {
            setLoading(false);
           // console.error("خطا در ثبت:", error);
            showMessage("خطا در ارتباط با سرور", "error");
        }
    };

    // تغییرات تاریخ
    const handleDateChange = (name, dateObject) => {
        form.setFieldsValue({ [name]: dateObject });
        if (name === "fromDate_Shamsi") setFromDate(dateObject);
        if (name === "toDate_Shamsi") setToDate(dateObject);
    };

    return (
        <div className="add-object-container">
            {/* هدر */}
            <Card className="add-object-header">
                <Row align="middle" gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={24}>
                        <div className="sectionTitle">
                            <Title level={3} style={{ margin: 0, color: "#007bff" }}>
                                <SaveOutlined style={{ marginLeft: 8 }} />
                                ثبت تاریخ خارج از سرویس 
                            </Title>
                            <Text type="secondary" style={{ fontSize: 14 }}>
                                {objectInstanceTitle}
                            </Text>
                        </div>
                    </Col>
                </Row>
            </Card>

            {/* فرم */}
            <Card className="add-object-form-card">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSubmit}
                    initialValues={{
                        description: ""
                    }}
                >
                    <Row gutter={[24, 0]}>
                        {/* تاریخ شروع */}
                        <Col xs={24} sm={12} md={12} lg={8}>
                            <Form.Item
                                name="fromDate_Shamsi"
                                label={
                                    <Space>
                                        <CalendarOutlined style={{ color: "#007bff" }} />
                                        <Text strong>تاریخ شروع</Text>
                                        <Text type="danger">*</Text>
                                    </Space>
                                }
                                rules={[
                                    { required: true, message: "تاریخ شروع را وارد کنید" }
                                ]}
                            >
                                <DatePicker
                                    calendar={persian}
                                    locale={persian_fa}
                                    format="YYYY-MM-DD"
                                    value={fromDate}
                                    onChange={(dateObject) => handleDateChange("fromDate_Shamsi", dateObject)}
                                    placeholder="انتخاب تاریخ شروع"
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        borderRadius: "5px",
                                        border: "1px solid #d9d9d9",
                                        padding: "0 11px"
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        {/* تاریخ پایان */}
                        <Col xs={24} sm={12} md={12} lg={8}>
                            <Form.Item
                                name="toDate_Shamsi"
                                label={
                                    <Space>
                                        <CalendarOutlined style={{ color: "#28a745" }} />
                                        <Text strong>تاریخ پایان</Text>
                                        <Text type="danger">*</Text>
                                    </Space>
                                }
                                rules={[
                                    { required: true, message: "تاریخ پایان را وارد کنید" },
                                    {
                                        validator: (_, value) => {
                                            if (fromDate && value && value < fromDate) {
                                                return Promise.reject("تاریخ پایان باید بعد از تاریخ شروع باشد");
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <DatePicker
                                    calendar={persian}
                                    locale={persian_fa}
                                    format="YYYY-MM-DD"
                                    value={toDate}
                                    onChange={(dateObject) => handleDateChange("toDate_Shamsi", dateObject)}
                                    placeholder="انتخاب تاریخ پایان"
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        borderRadius: "5px",
                                        border: "1px solid #d9d9d9",
                                        padding: "0 11px"
                                    }}
                                    minDate={fromDate || undefined}
                                />
                            </Form.Item>
                        </Col>

                        {/* علت */}
                        <Col xs={24} sm={24} md={24} lg={8}>
                            <Form.Item
                                label={
                                    <Space>
                                        <TagOutlined style={{ color: "#ffc107" }} />
                                        <Text strong>علت</Text>
                                        <Text type="danger">*</Text>
                                    </Space>
                                }
                                required
                            >
                                <CustomTypeCombo
                                    parentId={reasonParentId}
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    placeHolder="انتخاب علت"
                                    onChange={(value) => setReasonId(value)}
                                    value={reasonId}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        </Col>

                        {/* توضیحات - تمام عرض */}
                        <Col xs={24} sm={24} md={24} lg={24}>
                            <Form.Item
                                name="description"
                                label={
                                    <Space>
                                        <FileTextOutlined style={{ color: "#17a2b8" }} />
                                        <Text strong>توضیحات</Text>
                                    </Space>
                                }
                            >
                                <TextArea
                                    rows={4}
                                    placeholder="توضیحات (اختیاری)"
                                    maxLength={500}
                                    showCount
                                    style={{
                                        borderRadius: "5px",
                                        border: "1px solid #d9d9d9",
                                        padding: "10px",
                                        resize: "vertical"
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        {/* هشدار تاریخ */}
                        {fromDate && toDate && fromDate > toDate && (
                            <Col xs={24}>
                                <Alert
                                    message="خطا در تاریخ"
                                    description="تاریخ پایان نمی‌تواند قبل از تاریخ شروع باشد"
                                    type="error"
                                    showIcon
                                    style={{ marginBottom: 16 }}
                                />
                            </Col>
                        )}
                    </Row>

                    {/* دکمه‌ها */}
                    <Divider />
                    <Row justify="center" gutter={[16, 16]}>
                        <Col xs={12} sm={8} md={6} lg={4}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                icon={<CheckOutlined />}
                                block
                                size="large"
                                style={{
                                    borderRadius: "10px",
                                    height: "45px",
                                    fontSize: "16px"
                                }}
                            >
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={8} md={6} lg={4}>
                            <Button
                                icon={<RollbackOutlined />}
                                onClick={cancelInsert}
                                block
                                size="large"
                                style={{
                                    borderRadius: "10px",
                                    height: "45px",
                                    fontSize: "16px",
                                    backgroundColor: "#6c757d",
                                    color: "#fff",
                                    borderColor: "#6c757d"
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = "#5a6268";
                                    e.target.style.borderColor = "#545b62";
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = "#6c757d";
                                    e.target.style.borderColor = "#6c757d";
                                }}
                            >
                                انصراف
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};